import { StyleSheet, View } from 'react-native';
import { VideoView } from 'expo-video';
import { ThemedText } from '@/components/ThemedText';
import { useScale } from '@/hooks/useScale';
import { useCountdown } from '@/hooks/useCountdown';
import { colors } from '@/constants/colors';

type Props = {
  onComplete: () => void;
};

export default function CountdownOverlay({ onComplete }: Props) {
  const scale = useScale();
  const { step, isActive, player } = useCountdown(onComplete);

  if (!isActive) return null;

  const isNumber = typeof step === 'number';
  const displayValue = isNumber ? String(step) : "Let's Go!";

  return (
    <View style={styles.overlay}>
      <VideoView player={player} style={styles.hiddenPlayer} />
      {isNumber && (
        <ThemedText style={[styles.label, { fontSize: 24 * scale }]}>
          Workout starting in
        </ThemedText>
      )}
      <ThemedText
        style={[
          styles.countValue,
          {
            fontSize: (isNumber ? 120 : 48) * scale,
            lineHeight: (isNumber ? 130 : 58) * scale,
          },
        ]}
      >
        {displayValue}
      </ThemedText>
    </View>
  );
}

const styles = StyleSheet.create({
  overlay: {
    ...StyleSheet.absoluteFill,
    backgroundColor: colors.brand.primary,
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10,
  },
  hiddenPlayer: {
    width: 0,
    height: 0,
    position: 'absolute',
  },
  label: {
    color: 'rgba(255, 255, 255, 0.85)',
    fontWeight: '600',
    marginBottom: 8,
  },
  countValue: {
    color: '#fff',
    fontWeight: '700',
  },
});
